import React, { useContext, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { ExitToApp } from '@mui/icons-material';
import { NavLink } from 'react-router-dom';
import { Box, Toolbar, AppBar, IconButton, Typography } from '@mui/material';

import IntlMessages from 'util/IntlMessages';

const styles = {
  menu: {
    color: 'white',
    padding: 1,
    marginRight: 2,
    fontSize: 16,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1);',
    },
    borderRadius: 1,
  },
  toolbar: {
    height: '100%',
  },
  appbar: {
    height: '60px',
  },
};

const HorizontalHeader = () => {
  const onLogout = (e) => {
    Auth.signOut();
  };

  return (
    <AppBar position="sticky" sx={styles.appbar}>
      <Toolbar sx={styles.toolbar}>
        <Link to="/">
          <Box sx={{ marginRight: 4 }}>
            <img
              src={require('assets/images/logo.png')}
              alt="Neo"
              title="Neo"
              height="40px"
            />
          </Box>
        </Link>

        <NavLink to="/gwreports">
          <Typography variant="h6" sx={styles.menu}>
            <IntlMessages id="neo.gateway.reports.uniqueUsers" />
          </Typography>
        </NavLink>

        <NavLink to="/gateway/resources">
          <Typography variant="h6" sx={styles.menu}>
            <IntlMessages id="neo.gateway.resources" />
          </Typography>
        </NavLink>

        <NavLink to="/gateway/accessTest">
          <Typography variant="h6" sx={styles.menu}>
            <IntlMessages id="neo.gateway.accessTest" />
          </Typography>
        </NavLink>
        <NavLink to="/gateway/nx">
          <Typography variant="h6" sx={styles.menu}>
            <IntlMessages id="neo.gateway.nx" />
          </Typography>
        </NavLink>

        <Box sx={{ flexGrow: 1 }}></Box>

        <IconButton
          sx={styles.menu}
          onClick={() => {
            onLogout();
          }}
        >
          <ExitToApp />
        </IconButton>
      </Toolbar>

      {/* Invisible Toolbar to push content below the AppBar */}
      <Toolbar />
    </AppBar>
  );
};

export default HorizontalHeader;
